module.exports = __webpack_public_path__ + "static/media/knauf-johns-manville-insulation.5cc980df.jpg";